import { IconNamesEnum } from 'ngx-bootstrap-icons'
import { creditorsRange, dollarRange, employeesRange, industryCheckbox, revenueRange, situationTypes, marketsCheckbox, DistressedSituationReason, PartyInInterestRoles, StatutoryOtherRoles, OtherAdvisorRoles, LegalAdvisorRoles, FinancialAdvisorRoles, DebtorRoles, GroupType, GroupDebtType, FilingType, JudgeName, SituationName, CourtName, CaseStatus, SicSearch, MarketTickers } from 'src/app/shared/components/filtering-search-component-base/filtering-search-common-definitions'
import { SearchCheckboxOption, SearchMultiAutoCompleteOption, SearchDateRangeOption, SearchNumberRangeOption, SearchOptionGroup, SearchOptionType, SearchStringOption } from 'src/app/shared/components/filtering-search-component-base/filtering-search-types'


export const organizationsSearchOptionGroups: SearchOptionGroup[] = [
    {
        groupName: "Role",
        visible: true,
        colour: '#9BCFB2',
        options: [
            {
                icon: IconNamesEnum.InputCursorText,
                id: 'name',
                name: 'Organization Name',
                type: SearchOptionType.multiautocomplete,
                required: [],
                display: 'follow',
                tableColumn: {
                    visible: true,
                },
                lastResort: true,
                items: [],
                filterby: 'role',
                searchServiceParameter: {
                    area: 'organizations/autocomplete',
                    parameters: {
                        name: {
                            name: "name",
                            type: "stringinput",
                            format: 'autocomplete',
                            returndata: 'brief',
                        }
                    },
                    window: {
                        start: 1,
                        size: 5,
                    }
                },
            } as SearchMultiAutoCompleteOption,
            MarketTickers,
            {
                icon: IconNamesEnum.Buildings,
                id: 'involvementgraphs',
                type: SearchOptionType.checkboxes,
                name: 'Involvement Type',
                display: 'barchart',
                tableColumn: {
                    locked: false,
                    sortable: false,
                    showInDownloads: false,
                    visible: true,
                },
                active: false,
                selected: false,
                visible: true,
                numberChecked: 0,
                checkboxes: [
                    {
                        name: 'Advisor',
                        value: '6',
                        checked: true,
                    },
                    {
                        name: 'Distressed Entity/Debtor',
                        value: '1',
                        checked: true,
                    },
                    {
                        name: 'Creditor/Party in Interest',
                        value: '11_21_26_56',
                        checked: true,
                    },
                    {
                        name: 'Statutory/Other',
                        value: '31_36_41_46',
                        checked: true,
                    },
                    {
                        name: 'Group Member',
                        value: '51',
                        checked: true,
                    }
                ]
            } as SearchCheckboxOption,
            {
                icon: IconNamesEnum.Calendar4Range,
                id: 'tally',
                type: SearchOptionType.numberrange,
                name: 'Total Involvements',
                minValue: 1,
                visible: false,
                maxValue: 2000,
                display: 'number',
                depends: {
                    'wibble': ['wobble'],
                },
                tableColumn: {
                    locked: true,
                    sortable: true,
                    visible: true,
                },
                options: {
                    floor: 1,
                    ceil: 2000,
                    logScale: true,
                },
                prefix: '',
                suffix: '',
            } as SearchNumberRangeOption,
            {
                icon: IconNamesEnum.Person,
                id: 'last_involvement_situation',
                type: SearchOptionType.stringinput,
                name: 'Last Involvement',
                depends: {
                    'wibble': ['wobble'],
                },
                tableColumn: {
                    locked: true,
                    sortable: false,
                    visible: true,
                },
                searchString: '',
                matchingOption: 'phrase',
                matchingOptionTypes: {
                    exactPhrase: true,
                    allWords: true,
                    someWords: true,
                    booleanMode: false,
                }

            } as SearchStringOption,
            {
                icon: IconNamesEnum.Person,
                id: 'last_involvement_type',
                type: SearchOptionType.stringinput,
                name: 'Last Involvement Role',
                depends: {
                    'wibble': ['wobble'],
                },
                tableColumn: {
                    locked: true,
                    sortable: false,
                    visible: true,
                },
                searchString: '',
                matchingOption: 'phrase',
                matchingOptionTypes: {
                    exactPhrase: true,
                    allWords: true,
                    someWords: true,
                    booleanMode: false,
                }

            } as SearchStringOption,
            {
                icon: IconNamesEnum.Calendar4Range,
                id: 'last_involvement_date',
                type: SearchOptionType.daterange,
                name: 'Date of Last Involvement',
                depends: {
                    'wibble': ['wobble'],
                },
                tableColumn: {
                    visible: true,
                    sortable: true,
                },
                minDate: new Date(),
                maxDate: new Date(),

            } as SearchDateRangeOption,
        ]
    },

    {
        groupName: "Group",
        visible: true,
        colour: '#9BCFB2',
        dependsMust: {
            "involvementgraphs": ['51']
        },
        options: [
            {
                ...GroupType,
                tableColumn: {
                    visible: false,
                    alwaysHidden: true
                },
            } as SearchCheckboxOption,
            {
                ...GroupDebtType,
                tableColumn: {
                    visible: false,
                    alwaysHidden: true
                },
            } as SearchCheckboxOption,
        ]
    },

    {
        groupName: "Distressed Entity/Debtors",
        visible: true,
        colour: '#9BCFB2',
        dependsMust: {
            "involvementgraphs": ['1']
        },
        options: [
            {
                ...DebtorRoles,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                }
            } as SearchCheckboxOption

        ]
    },

    {
        groupName: "Creditor/Party in Interest",
        visible: true,
        colour: '#9BCFB2',
        dependsMust: {
            "involvementgraphs": ['11_21_26_56']
        },
        options: [
            {
                ...PartyInInterestRoles,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                }
            } as SearchCheckboxOption,
            {
                icon: IconNamesEnum.At,
                id: 'organization_group_participation',
                name: 'Group Participation',
                type: SearchOptionType.checkboxes,
                tableColumn: {
                    alwaysHidden: true,
                    locked: false,
                    sortable: true,
                    visible: false,
                },
                active: false,
                selected: false,
                visible: true,
                numberChecked: 0,
                checkboxes: [
                    {
                        name: 'In a Group',
                        value: 'in_group',
                        checked: true,
                    },
                    {
                        name: 'Not in a Group',
                        value: 'not_in_group',
                        checked: true,
                    },
                ]
            } as SearchCheckboxOption,
        ]
    },
    {
        groupName: "Statutory/Other",
        visible: true,
        colour: '#9BCFB2',
        dependsMust: {
            "involvementgraphs": ['31_36_41_46']
        },
        options: [
            {
                ...StatutoryOtherRoles,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
            } as SearchCheckboxOption,
            {
                icon: IconNamesEnum.At,
                id: 'organization_group_participation_other',
                name: 'Group Participation',
                type: SearchOptionType.checkboxes,
                tableColumn: {
                    alwaysHidden: true,
                    locked: false,
                    sortable: true,
                    visible: false,
                },
                active: false,
                selected: false,
                visible: true,
                numberChecked: 0,
                checkboxes: [
                    {
                        name: 'In a Group',
                        value: 'in_group',
                        checked: true,
                    },
                    {
                        name: 'Not in a Group',
                        value: 'not_in_group',
                        checked: true,
                    },
                ]
            } as SearchCheckboxOption,
        ]
    },
    {
        groupName: "Advisor Options",
        visible: true,
        colour: '#9BCFB2',
        dependsMust: {
            "involvementgraphs": ['6']
        },
        options: [
            {
                icon: IconNamesEnum.At,
                id: 'advisee_group_participation',
                name: 'Advising',
                type: SearchOptionType.checkboxes,
                tableColumn: {
                    alwaysHidden: true,
                    locked: false,
                    sortable: true,
                    visible: false,
                },
                active: false,
                selected: false,
                visible: true,
                numberChecked: 0,
                checkboxes: [
                    {
                        name: 'Groups',
                        value: 'groups',
                        checked: true,
                    },
                    {
                        name: 'Parties',
                        value: 'individuals',
                        checked: true,
                    },
                ]
            } as SearchCheckboxOption,
            {
                ...GroupType,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                dependsMust: {
                    "advisee_group_participation": ['groups']
                },
                id: 'advisee_group_type',
                name: 'Advisee Group Type',
            } as SearchCheckboxOption,
            {
                ...GroupDebtType,
                dependsMust: {
                    "advisee_group_participation": ['groups']
                },
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                id: 'advisee_group_debt_type',
                name: 'Advisee Group Debt Type',
            } as SearchCheckboxOption,

            {
                icon: IconNamesEnum.At,
                id: 'involvement_subtype_lookupID_advisor',
                name: 'Advisor Type',
                type: SearchOptionType.checkboxes,
                tableColumn: {
                    alwaysHidden: true,
                    locked: false,
                    sortable: true,
                    visible: false,
                },
                active: false,
                selected: false,
                visible: true,
                numberChecked: 0,
                checkboxes: [
                    {
                        name: 'Financial',
                        value: '21',
                        checked: true,
                    },
                    {
                        name: 'Legal',
                        value: '16',
                        checked: true,
                    },
                    {
                        name: 'Other',
                        value: '26',
                        checked: true,
                    },
                ]
            } as SearchCheckboxOption,
            {
                ...FinancialAdvisorRoles,
                    dependsMust: {
                    "involvement_subtype_lookupID_advisor": ['21']
                },
            } as SearchCheckboxOption,
            {
                ...LegalAdvisorRoles,
                dependsMust: {
                    "involvement_subtype_lookupID_advisor": ['16']
                },
            },
            {
                ...OtherAdvisorRoles,
                dependsMust: {
                    "involvement_subtype_lookupID_advisor": ['26']
                },
            },
            {
                icon: IconNamesEnum.Buildings,
                id: 'involvement_type_lookupID_situationadvisee',
                type: SearchOptionType.checkboxes,
                name: 'Advisee Involvement',
                tableColumn: {
                    alwaysHidden: true,
                    locked: false,
                    sortable: true,
                    visible: false,
                },
                active: false,
                selected: false,
                visible: true,
                numberChecked: 0,
                dependsMust: {
                    "advisee_group_participation": ['individuals']
                },
                checkboxes: [
                    {
                        name: 'Distressed Entity/Debtor',
                        value: '1',
                        checked: true,
                    },
                    {
                        name: 'Creditor/Party in Interest',
                        value: '11_21_26_56',
                        checked: true,
                    },
                    {
                        name: 'Statutory/Other',
                        value: '31_36_41_46',
                        checked: true,
                    }
                ]
            } as SearchCheckboxOption,
            {
                ...PartyInInterestRoles,
                id: 'involvement_subtype_lookupID_situationadvisee',
                name: 'Advisee Creditor/Party in Interest Roles',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                dependsMust: {
                    "involvement_type_lookupID_situationadvisee": ["11_21_26_56"]
                }
            } as SearchCheckboxOption,
            {
                ...StatutoryOtherRoles,
                id: 'involvement_subtype_lookupID_situationadvisee',
                name: 'Advisee Statutory/Other Roles',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                dependsMust: {
                    "involvement_type_lookupID_situationadvisee": ['31_36_41_46']
                },
            } as SearchCheckboxOption,
            {
                ...DebtorRoles,
                id: 'involvement_subtype_lookupID_situationadvisee',
                name: 'Advisee Distressed Entity/Debtor Roles',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                dependsMust: {
                    "involvement_type_lookupID_situationadvisee": ["1"]
                }
            } as SearchCheckboxOption,

        ]
    },
    {
        groupName: "Situation",
        visible: true,
        colour: '#9BCFB2',
        options: [
            {
                ...SituationName,
                tableColumn: {
                    visible: false,
                },
            },
            {
                icon: IconNamesEnum.Calendar4Range,
                id: 'situational_date',
                type: SearchOptionType.daterange,
                name: 'Situation Date',
                tableColumn: {
                    locked: false,
                    sortable: false,
                    showInDownloads: false,
                    alwaysHidden: true,
                },
                minDate: new Date(),
                maxDate: new Date(),

            } as SearchDateRangeOption,
            {
                ...situationTypes,
                name: "Situation Types",
                tableColumn: {
                    visible: false,
                    showInDownloads: false,
                    alwaysHidden: true
                },
            } as SearchCheckboxOption,
            {
                ...industryCheckbox,

                id: 'case_industry_situation',
                name: 'Industries',
                display: 'barchart',
                tableColumn: {
                    visible: true,
                    sortable: false,
                    showInDownloads: false
                },
            } as SearchCheckboxOption,
            SicSearch,
            {
                ...marketsCheckbox,
                name: 'Markets',
                tableColumn: {
                    sortable: false,
                },
            } as SearchCheckboxOption,
            {
                ...DistressedSituationReason,
                tableColumn: {
                    alwaysHidden: true,
                    sortable: false

                },
            } as SearchCheckboxOption,
            {
                ...structuredClone(dollarRange),
                id: 'assets_range_situation',
                name: 'Assets Range',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },

            } as SearchCheckboxOption,
            {
                ...structuredClone(dollarRange),
                id: 'liabilities_range_situation',
                name: 'Liabilities Range',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
            } as SearchCheckboxOption,
            {
                ...revenueRange,
                id: 'revenue_range_situation',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },

            } as SearchCheckboxOption,
            {
                ...employeesRange,
                id: 'employees_range_situation',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
            } as SearchCheckboxOption,
            {
                ...creditorsRange,
                id: 'creditors_range_situation',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
            } as SearchCheckboxOption

        ]
    },
    {
        groupName: "Group",
        visible: true,
        colour: '#9BCFB2',
        depends: {
            "organization_group_participation": ['in_group']

        },
        options: [
            {
                ...GroupType,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                id: 'group_type_org',
            } as SearchCheckboxOption,
            {
                ...GroupDebtType,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                id: 'group_debt_type_org',
            } as SearchCheckboxOption,
        ]
    },
    {
        groupName: "Group",
        visible: true,
        colour: '#9BCFB2',
        depends: {
            "organization_group_participation_other": ['in_group']
        },
        options: [
            {
                ...GroupType,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                id: 'group_type_org_other',
            } as SearchCheckboxOption,
            {
                ...GroupDebtType,
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                },
                id: 'group_debt_type_org_other',
            } as SearchCheckboxOption,
        ]
    },
    {
        groupName: "Bankruptcy Case",
        visible: true,
        colour: '#9BCFB2',
        depends: {
            "situation_type": ['bankruptcy']
        },
        options: [
            {
                icon: IconNamesEnum.InputCursorText,
                id: 'case_name',
                name: 'Case name',

                lastResort: true,
                type: SearchOptionType.multiautocomplete,
                required: [],
                tableColumn: {
                    visible: false,
                    sortable: false
                },
                items: [],
                filterby: 'role',
                searchServiceParameter: {
                    area: 'situations',
                    parameters: {
                        entity_name: {
                            name: "name",
                            type: "stringinput",
                            format: 'autocomplete',
                            returndata: 'brief',
                        }
                    },
                    window: {
                        start: 1,
                        size: 5,
                    }
                },
            } as SearchMultiAutoCompleteOption,
            {
                ...FilingType,
                tableColumn: {
                    sortable: false,
                    visible: false,
                }
            } as SearchCheckboxOption,
            {
                icon: IconNamesEnum.Calendar4Range,
                id: 'case_confirmation_date',
                type: SearchOptionType.daterange,
                name: 'Confirmation Date',
                tableColumn: {
                    alwaysHidden: true,
                    visible: false,
                    sortable: false,
                },
                minDate: new Date(),
                maxDate: new Date(),

            } as SearchDateRangeOption,
            {
                ...CaseStatus,
                tableColumn: {
                    sortable: false,
                    visible: false,
                }
            } as SearchCheckboxOption,
            {
                ...CourtName,
                tableColumn: {
                    sortable: false,
                    visible: false,
                }
            } as SearchMultiAutoCompleteOption,
            {
                ...JudgeName,
                tableColumn: {
                    sortable: false,
                    visible: false,
                }
            } as SearchMultiAutoCompleteOption
        ]
    },


]